import { IEngagement } from "@wingspanhq/payments/dist/interfaces";
import { usePayeeRowsQuery } from "../../../../query/search/payee/queries/usePayeeRowsQuery";
import { WSPanel } from "@wingspanhq/fe-component-library";
import React from "react";
import { PayerPayeeEngagementStatus } from "@wingspanhq/payments/dist/interfaces/payerPayeeEngagement";
import { DataViewGrid } from "../../../../shared/components/DataView";
import { useAllPayeeEngagementsQuery } from "../../../../query/payeeEngagements/queries/useAllPayeeEngagementsQuery";

export const ActionEngagementDetails: React.FC<{ engagement: IEngagement }> = ({
  engagement
}) => {
  const engagementId = engagement.engagementId;

  const queryAllEngagements = useAllPayeeEngagementsQuery({
    filter: {
      engagementId
    },
    page: {
      size: 1
    }
  });

  const queryArchivedEngagements = useAllPayeeEngagementsQuery({
    filter: {
      engagementId,
      status: PayerPayeeEngagementStatus.Inactive
    },
    page: {
      size: 1
    }
  });

  const queryActiveEngagements = useAllPayeeEngagementsQuery({
    filter: {
      engagementId,
      status: { notIn: [PayerPayeeEngagementStatus.Inactive] }
    },
    page: {
      size: 1
    }
  });

  return (
    <WSPanel
      shimmer={
        queryAllEngagements.isLoading ||
        queryArchivedEngagements.isLoading ||
        queryActiveEngagements.isLoading
      }
    >
      <DataViewGrid
        gridColumns={2}
        data={[
          {
            label: "Engagement type name",
            value: engagement.name
          },
          {
            label: "Contractor engagements with historical data",
            value: queryAllEngagements.data?.summary.listSize
          },
          {
            label: "Active contractor engagements",
            value: queryActiveEngagements.data?.summary.listSize
          },
          {
            label: "Archived contractor engagements",
            value: queryArchivedEngagements.data?.summary.listSize
          }
        ]}
      />
    </WSPanel>
  );
};
